import React from "react"
import styles from "../Box/Box.module.css"
import { AiFillGithub } from "react-icons/ai"
import { IconContext } from "react-icons"
import { IoIosEye } from "react-icons/io"
function Box(props) {
  const { image, github, page, alt } = props
  return (
    <>
      <div className={styles.square}>
        <img src={image} alt={alt} />
        <div className={styles.content}>
          <IconContext.Provider
            value={{
              color: "white",
              size: "2em",
              className: "global-class-name",
            }}
          >
            <h3>
              <a href={github}>
                <AiFillGithub /> <span>CODE</span>
              </a>
            </h3>
            <h3>
              <a href={page}>
                <IoIosEye /> <span>LIVE</span>
              </a>
            </h3>
          </IconContext.Provider>
        </div>
      </div>
    </>
  )
}

export default Box
